import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { CartServiceV2, CartState } from '@cakeiteasy/order-process/index';
import { WebStorageService } from '@cakeiteasy/web-utils';

import { LocationManagerService } from '@cakeiteasy/web-utils';

@Injectable()
export class CartHttpInterceptor implements HttpInterceptor {
  constructor(private _injector: Injector, private _store: Store<CartState>) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const _locationManager = this._injector.get(LocationManagerService);
    const _storage = this._injector.get(WebStorageService);
    const _cartService = this._injector.get(CartServiceV2);
    let domain = _locationManager.getDomainName() || '';

    // Temporary fix it could be removed with time
    if (_cartService.getKey() && _cartService.getKey().indexOf('STORE') >= 0) {
      _cartService.cleanKey();
    }
    // --------

    // X-Cart-Key-Header: any string no longer 16 chars. Empty string by default.
    const setHeaders = {
      'x-source-header': 'MARKETPLACE',
      'x-cart-key-header': _cartService.getKey() || `MARKETPLACE-${domain.toUpperCase()}`
    };

    const webStorage = _storage.getMostPersistentStorage();
    if (webStorage.get('session_id')) {
      setHeaders['x-session-key-header'] = webStorage.get('session_id');
    }

    req = req.clone({
      setHeaders
    });

    return next.handle(req)
      .pipe(catchError((error) => {
        return throwError(error);
      }));
  }
}
